import { render, staticRenderFns } from "./TargetDestinationForm.vue?vue&type=template&id=940a8f8a"
import script from "./TargetDestinationForm.vue?vue&type=script&lang=js"
export * from "./TargetDestinationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports